import { nextTick } from 'vue';

export function lowPriorityCallback(cb: Function) {
	if ('requestIdleCallback' in window) {
		window.requestIdleCallback(() => cb());
	} else {
		nextTick(() => cb());
	}
}
